// extracted by mini-css-extract-plugin
export default {"wrapper":"css_wrapper__t7jhX","loader":"css_loader__hfRVA","spin":"css_spin__VD9OW"};